import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { BAO_TYPE } from '@/views/study/constance';
import { getStrategy as _getStrategy } from '@/api/modules/study';
var VPS_CONTENT_STEP1_MAP = {
  1: '查看知识探索卡片',
  2: '完成题目作答',
  3: '完成题目作答',
  4: '完成题目作答'
};
var VPS_CONTENT_STEP2_MAP = {
  1: '在系统右上角输入框输入页码，观看学习视频',
  2: '在系统右上角输入框输入页码，核对题目答案',
  3: '在系统右上角输入框输入页码，查看解析，提交题目作答结果',
  4: '在系统右上角输入框输入页码，查看解析，提交题目作答结果'
};
export default {
  name: 'StudyGuide',
  props: {
    outlineId: {
      type: Number,
      required: true
    },
    boxInfo: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      // 学习进度
      progress: '0/0',
      // 策略列表
      strategyList: [],
      // 当前选中的策略
      selected: {},
      // 位置
      position: 0,
      // 左箭头是否置灰
      isLeftDisabled: true,
      // 右箭头是否置灰
      isRightDisabled: true,
      showLoading: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['subjectGetters', 'userActionZxbInfo', 'closeCodeDialog'])), {}, {
    // 策略列表位置
    strategyPosition: function strategyPosition() {
      return -this.position * 144 + 'px';
    }
  }),
  watch: {
    outlineId: function outlineId() {
      this.getStrategy();
    },
    closeCodeDialog: function closeCodeDialog(val) {
      if (val) {
        this.getStrategy();
      }
    }
  },
  created: function created() {
    this.getStrategy();
  },
  methods: {
    _getVolumnTypeImg: function _getVolumnTypeImg() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var IMG_TEXT_URL = {
        1: this.$resource('text-guide-study.png'),
        2: this.$resource('text-guide-practice.png')
      };
      return {
        volumeTypeImg: IMG_TEXT_URL[type],
        volumeIconImg: BAO_TYPE[type].icon
      };
    },
    getStrategy: function getStrategy() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, _yield$_getStrategy, status, data, selectedIndex, diff, i, hasFinished;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.outlineId) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this.showLoading = true;
                params = {
                  outlineId: _this.outlineId
                };
                _context.next = 6;
                return _getStrategy(params);

              case 6:
                _yield$_getStrategy = _context.sent;
                status = _yield$_getStrategy.status;
                data = _yield$_getStrategy.data;
                // 初始化位置
                _this.position = 0;
                _this.isLeftDisabled = true;

                if (status === 1 && Array.isArray(data)) {
                  _this.strategyList = data.map(function (item) {
                    var volumeType = item.volumeType,
                        startPage = item.startPage,
                        businessId = item.businessId,
                        tagName = item.tagName,
                        name = item.name,
                        vpsContentType = item.vpsContentType;
                    var formatName = volumeType === 1 ? tagName : name || '练习题';
                    return _objectSpread(_objectSpread(_objectSpread({}, item), _this._getVolumnTypeImg(volumeType)), {}, {
                      key: businessId + '_' + volumeType,
                      volumeTypeName: BAO_TYPE[volumeType].name,
                      currentPage: 'P' + startPage,
                      formatName: formatName,
                      step1: VPS_CONTENT_STEP1_MAP[vpsContentType],
                      step2: VPS_CONTENT_STEP2_MAP[vpsContentType]
                    });
                  }); // 是否右侧置灰

                  _this.isRightDisabled = _this.strategyList.length <= 5; // 选中策略

                  selectedIndex = _this.strategyList.findIndex(function (item) {
                    return item.selected === 1;
                  }) || 0;
                  _this.selected = _this.strategyList[selectedIndex];
                  diff = selectedIndex - 2;

                  for (i = 0; i < diff; i++) {
                    _this.move('right');
                  } // 学习进度


                  hasFinished = _this.strategyList.filter(function (item) {
                    return item.status;
                  });
                  _this.progress = hasFinished.length + '/' + data.length;
                } else {
                  _this.strategyList = [];
                  _this.selected = {};
                  _this.progress = '0/0';
                  _this.isLeftDisabled = true;
                  _this.isRightDisabled = true;
                }

                _this.showLoading = false;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    setSelected: function setSelected(item) {
      if (item.key === this.selected.key) {
        return;
      }

      this.selected = item;
    },
    // 移动策略列表
    move: function move(direction) {
      if (direction === 'left') {
        if (this.position > 0) {
          this.position--;
        }
      } else if (direction === 'right') {
        if (this.position < this.strategyList.length - 5) {
          this.position++;
        }
      }

      this.isLeftDisabled = this.position === 0;
      this.isRightDisabled = this.position >= this.strategyList.length - 5;
    },
    // 输入页码
    inputPageCode: function inputPageCode() {
      var boxId = this.boxInfo.boxId;
      var _this$selected = this.selected,
          preciousType = _this$selected.volumeType,
          volumeTypeName = _this$selected.volumeTypeName;
      var subjectBoxIdType = {
        subject: this.subjectGetters,
        boxId: boxId,
        preciousType: preciousType
      };

      var zxbInfo = _objectSpread({}, this.userActionZxbInfo);

      zxbInfo[this.subjectGetters] = {
        // 改变值
        box: _objectSpread({}, this.boxInfo),
        precious: {
          'name': volumeTypeName,
          'type': preciousType
        }
      }; // 显示提示

      this.$store.dispatch('setShowPageCue', true);
      this.$store.dispatch('setPreciousMessage', subjectBoxIdType);
      this.$store.dispatch('setPreciousInfo', zxbInfo);
    }
  }
};